var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Appbar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"header-space-tcdc",staticStyle:{"min-height":"284px"},style:({ 'visibility': _vm.renderFcp ? 'visible':'hidden' })})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }